import * as React from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import { Link } from 'libs/router';

import MediaPreview from 'components/MediaPreview';

import SystemMessageWrapperContext from '../wrapper/context/SystemMessageWrapperContext';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDateNoYear } from 'utils/date';
import { sanitizeGenericHtml } from 'utils/sanitize';
import { FUNC_RETURN_NULL } from '../utils/system-message';

import './system-message-ccm-outfit-declined.scss';

applyTranslations(require('./system-message-ccm-outfit-declined.i18n.json'));

const MSG_KEY = 'system_message_ccm_outfit_declined';

const SystemMessageCcmOutfitDeclined = (): JSX.Element => {
  const context = React.useContext(SystemMessageWrapperContext);
  const {
    campaign,
    subcampaign,
    message,
    renderAvatar = FUNC_RETURN_NULL
  } = context;

  const isCcm = campaign?.campaignType === 'ccm';
  const outfit = get(message, 'metadata.outfit', {});
  const outfitImages = outfit.outfitImages || [];
  const outfitImageMain = outfitImages[0] || {};
  const outfitDeclinedReason = outfit.declinedReason || null;

  const renderLink = (): React.ReactNode => {
    const deliverable = get(message, 'metadata.deliverable', {});
    const text = __t(`${MSG_KEY}.links.view_content`);

    return (
      <Link
        to={`/campaigns${isCcm ? '/ccm' : ''}/${campaign?.id}/deliverables?subcampaignId=${subcampaign?.id}&tab=content_approval#deliverable-${deliverable?.id}`}
        target="_blank"
        className="system-message-ccm-outfit-declined__link"
        title={text}
      >
        {text}
      </Link>
    );
  };

  const renderPrimaryText = (): React.ReactNode => {
    const text = __t(`${MSG_KEY}.messages.declined_content`);

    return (
      <div
        className="system-message-ccm-outfit-declined__primary-text"
        title={text}
      >
        {text}
      </div>
    );
  };

  const renderOutfitImage = (): React.ReactNode => (
    <div className="system-message-ccm-outfit-declined__outfit-image">
      <MediaPreview
        attachment={{
          id: `outfit-declined-image-${outfitImageMain.sortOrder}`,
          url: outfitImageMain.url,
          format: 'image'
        }}
        width={126}
        height={126}
      />
    </div>
  );

  const renderOutfitDeclinedReason = (): React.ReactNode => (
    <div
      className="system-message-ccm-outfit-declined__declined-reason"
      title={outfitDeclinedReason}
    >
      "{outfitDeclinedReason}"
    </div>
  );

  const renderAdditionalText = (): React.ReactNode => {
    const timeline = get(message, 'metadata.campaign.timeline', {});
    const text = __t(`${MSG_KEY}.messages.additional_text`, {
      date: getDisplayDateNoYear(timeline?.taskContentGoLiveDate)
    });

    return (
      <div
        className="system-message-ccm-outfit-declined__additional-text"
        title={text}
        dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(text) }}
      />
    );
  };

  return (
    <React.Fragment>
      {renderAvatar('info-inside-circle-white-bg-custom-fg')}
      <div className="system-message-ccm-outfit-declined">
        {renderPrimaryText()}
        {
          !isEmpty(outfitImageMain) &&
            renderOutfitImage()
        }
        {
          !isNil(outfitDeclinedReason) &&
            renderOutfitDeclinedReason()
        }
        {renderAdditionalText()}
        {renderLink()}
      </div>
    </React.Fragment>
  );
};

export default SystemMessageCcmOutfitDeclined;
